export class Location{
 name : String;
 country : String;
 adress1 : String;
 adress2 : String;
 zipcode : String;
 city : String;
 AccountId : String;
}
